module.exports = __webpack_public_path__ + "odinstatic/media/sidebar-shield-inactive.8f21e72b.svg";